$(function(){	
	 onBlind();
});
// возвращает cookie с именем name, если есть, если нет, то undefined
function getCookie(name) {
  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}
// 
function setCookie(name, value, options) {
  options = options || {};

  var expires = options.expires;

  if (typeof expires == "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  var updatedCookie = name + "=" + value;

  for (var propName in options) {
    updatedCookie += "; " + propName;
    var propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  document.cookie = updatedCookie;
}

function deleteCookie(name) {
  setCookie(name, "", {
    expires: -1,
    path	: '/'
  });
}

function onBlind(){
	$('a.on_blind').on('click', function(){
		 deleteCookie('blind_on');
		// alert('blind_on');
		 deleteCookie('font_b');
		 deleteCookie('gamma_b');
		location.reload();
		// $(this).removeClass('blind_on');
		// $(this).addClass('off_blind');
		 $('body').scrollTop(0);
		return false;
	});
	
	$('a.off_blind').on('click', function(){
		 setCookie('blind_on', 1, {
		 	expires : 60*60*24*7,
		 	path	: '/'
	 	});
		 setCookie('font_b', 0, {
		 	expires : 60*60*24*7,
		 	path	: '/'
	 	});
		 setCookie('gamma_b', 0, {
		 	expires : 60*60*24*7,
		 	path	: '/'
	 	});
		// $(this).removeClass('off_blind');
		// $(this).addClass('blind_on');
		location.reload();
		 $('body').scrollTop(0);
		return false;
	});
	$('a.font_ch').on('click', function(){
		$atr=$(this).attr('data-val');
		 setCookie('font_b', $atr, {
		 	expires : 60*60*24*7,
		 	path	: '/'
	 	});
		location.reload();
		return false;
	});
	$('a.gamma_ch').on('click', function(){
		$atr=$(this).attr('data-val');
		 setCookie('gamma_b', $atr, {
		 	expires : 60*60*24*7,
		 	path	: '/'
	 	});
		$(this).scrollTop(0);
		location.reload();
		return false;
	});
}